import { cn } from '@/utils/tailwind.util';
import { type HeroCardData } from '../../types';
import { AuthorInfo } from '../Metadata/AuthorInfo';
import { CopyCounter } from '../Metadata/CopyCounter';
import { DateCounter } from '../Metadata/DateCounter';
import { Divider } from '../Metadata/Divider';
import { OriginalAuthor } from '../Metadata/OriginalAuthor';
import { PlayCounter } from '../Metadata/PlayCounter';
type HeroMetadataProps = {
  data: HeroCardData;
  className?: string;
};
export const HeroMetadata = ({
  data,
  className
}: HeroMetadataProps) => {
  const {
    author,
    metadata,
    originalAuthors
  } = data;
  return <div className={cn('flex flex-wrap items-center min-h-[40px] w-full', 'tablet-sm:gap-x-sm tablet-sm:gap-y-0', 'flex-col items-start gap-2xs', className)} data-sentry-component="HeroMetadata" data-sentry-source-file="HeroMetadata.tsx">
      {/* Author Info Row - Mobile: separate row, Desktop: inline with divider */}
      {author && <>
          {/* Mobile: Author on separate row */}
          <div className="flex shrink-0 tablet-sm:hidden">
            <AuthorInfo username={author.username} authorId={author.id} avatarData={author.avatarData} />
          </div>
        </>}

      {/* Main Metadata Row */}
      <div className={cn('flex flex-wrap items-center gap-sm w-full')}>
        {/* Desktop: Author inline with metadata */}
        {author && <>
            <div className="hidden shrink-0 tablet-sm:flex">
              <AuthorInfo username={author.username} authorId={author.id} avatarData={author.avatarData} />
            </div>
            <div className="hidden shrink-0 tablet-sm:flex">
              <Divider />
            </div>
          </>}
        {/* Date Counter */}
        {metadata.createdAt && <>
            <DateCounter date={metadata.createdAt} className="shrink-0 text-caption-lg-medium tablet-sm:text-body-md-medium" />
            {/* Divider - Desktop only */}
            <div className="hidden shrink-0 tablet-sm:flex">
              <Divider />
            </div>
          </>}

        {/* Copy Counter - Mobile only: before Play */}
        <div className="flex shrink-0 items-center gap-sm tablet-sm:hidden">
          {metadata.copyCount > 0 && <CopyCounter count={metadata.copyCount} className="text-caption-lg-medium" />}
        </div>

        {/* Play Counter */}
        <PlayCounter count={metadata.playCount} className="shrink-0 text-caption-lg-medium tablet-sm:text-body-md-medium" data-sentry-element="PlayCounter" data-sentry-source-file="HeroMetadata.tsx" />

        {/* Copy Counter - Desktop only: after Play */}
        {metadata.copyCount > 0 && <div className="hidden shrink-0 items-center gap-sm tablet-sm:flex">
            <>
              <Divider />
              <CopyCounter count={metadata.copyCount} className="text-body-md-medium" />
            </>
          </div>}

        {/* Original Author */}
        {originalAuthors.length > 0 && <>
            <Divider />
            <OriginalAuthor authors={originalAuthors} className="shrink-0" />
          </>}
      </div>
    </div>;
};